export const TimeMask = [/\d/, /\d/, ':', /\d/, /\d/];

// (xx) x xxxx-xxxxx
// (xx) xxxx-xxxxx
export function phoneMask(userInput) {
	const numbers = userInput.match(/\d/g);
	let numberLength = 0;
	if (numbers) {
		numberLength = numbers.join('').length;
	}

	if (numberLength > 10) {
		return [
			'(',
			/[1-9]/,
			/[1-9]/,
			')',
			' ',
			/\d/,
			/\d/,
			/\d/,
			/\d/,
			/\d/,
			' ',
			'-', // nao trocar por ' - ', a mascara vai parar de funcionar
			' ',
			/\d/,
			/\d/,
			/\d/,
			/\d/,
		];
	}
	return [
		'(',
		/[1-9]/,
		/[1-9]/,
		')',
		' ',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		' ',
		'-', // nao trocar por ' - '
		' ',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
	];
}

// (xx.xxx.xxx/xxxx-xx);
export const CNPJMask = [
	/\d/,
	/\d/,
	'.',
	/\d/,
	/\d/,
	/\d/,
	'.',
	/\d/,
	/\d/,
	/\d/,
	'/',
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	'-',
	/\d/,
	/\d/,
];

// xxx/xxxx
export const empenhoMask = [
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	'/',
	/\d/,
	/\d/,
	/\d/,
	/\d/,
];

// xx.xxx-xxx
export const CEPMask = [
	/\d/,
	/\d/,
	'.',
	/\d/,
	/\d/,
	/\d/,
	'-',
	/\d/,
	/\d/,
	/\d/,
];

// x*,xx
export function moneyMask(userInput) {
	let response = [',', /\d/, /\d/];

	const numbers = userInput.match(/\d/g);
	let numberLength = 0;
	if (numbers) {
		numberLength = numbers.join('').length;
	}

	if (numberLength > 2) {
		response = [];
		for (let i = 0; i < numberLength; i++) {
			response.push(/\d/);
			if (i === numberLength - 3) {
				response.push(',');
			}
		}
	}

	return response;
}

export function numberMask(userInput) {
	const response = [];

	const numbers = userInput.match(/\d/g);
	let numberLength = 0;
	if (numbers) {
		numberLength = numbers.join('').length;
	}

	for (let i = 0; i < numberLength; i++) {
		response.push(/\d/);
	}
	return response;
}

export function getMaskedPhoneNumber(value) {
	return value.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
}
